// API service for AnyVolt website
// Handles communication with the backend API

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.anyvolt.com/v1';

// Function to track download events
const trackDownload = async (platform, sourcePage) => {
  try {
    const response = await fetch(`${API_BASE_URL}/analytics/download`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        platform,
        sourcePage,
        userAgent: navigator.userAgent,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error tracking download:', error);
    // Return a successful response even if tracking fails to not impact UX
    return { success: true, message: 'Download tracking event processed' };
  }
};

// Function to submit contact form
const submitContactForm = async (name, email, subject, message) => {
  try {
    const response = await fetch(`${API_BASE_URL}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        subject,
        message,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

// Function to submit trial signup
const submitTrialSignup = async (email, serviceType, firstName, lastName, companyName, businessType) => {
  try {
    const response = await fetch(`${API_BASE_URL}/trial`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        serviceType,
        firstName,
        lastName,
        ...(serviceType === 'fleet' && { companyName, businessType }), // Only include for fleet
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error submitting trial signup:', error);
    throw error;
  }
};

// Function to get pricing information
const getPricingInfo = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/pricing`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching pricing info:', error);
    throw error;
  }
};

// Function to get support resources
const getSupportResources = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/support`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching support resources:', error);
    throw error;
  }
};

export {
  trackDownload,
  submitContactForm,
  submitTrialSignup,
  getPricingInfo,
  getSupportResources
};